import {
  ChangeDetectionStrategy,
  Component,
  inject,
  resource,
  signal,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";

// local imports
import { CatalogConstants, CatalogStateService, DocumentModel } from "@app/catalog";
import { CatalogCommonConstants } from "@app/catalog-common";

@Component({
  selector: "room-content-property",
  standalone: false,
  templateUrl: "./room-content-property.component.html",
  styleUrl: "./room-content-property.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoomContentPropertyComponent {
  private route = inject(ActivatedRoute);
  private catalogStateService = inject(CatalogStateService);

  public readonly is3DViewerEnable = signal(false);
  public catalogConstants = CatalogConstants;

  public propertyResource = resource({
    request: () => ({
      id: this.route.snapshot.paramMap.get("id"),
      departmentId: this.route.snapshot.queryParamMap.get(
        CatalogCommonConstants.ROUTE_PARAMS.DEPARTMENT_ID
      ),
      programId: this.route.snapshot.queryParamMap.get(
        CatalogCommonConstants.ROUTE_PARAMS.PROGRAM_ID
      ),
      projectId: this.route.snapshot.queryParamMap.get(
        CatalogCommonConstants.ROUTE_PARAMS.PROJECT_ID
      ),
    }),
    loader: async ({ request }) => {
      const property = await this.catalogStateService.getRoomContentProperty(
        request.id,
        request.programId,
        request.projectId
      );

      if (property.documents) {
        const filteredDocuments = property.documents().filter(
          (doc: DocumentModel) => !doc.superseded()
        );
        property.documents.set(filteredDocuments);
      }

      return property;
    },
  });


  public open3DViewer(): void {
    this.is3DViewerEnable.set(true);
  }
}